export default "__VITE_ASSET__OzJP391i__"